import { Category } from 'interfaces'

export const convertCategoriesListToOptions = (categories: Category[]) => {
  if (!categories?.length) return []

  return categories?.map(({ id, name }) => ({ name, value: id }))
}
